import api from '../../../services/api';

/**
 * ragChatService.js
 * Handles all RAG/AI chat API calls for the Velocity AI bot.
 */

/**
 * Fetch all sessions for a given RFP.
 * GET /rag/rfp/{rfp_id}/sessions
 */
export const fetchSessions = async (rfpId) => {
    const response = await api.get(`/rag/rfp/${rfpId}/sessions`);
    return response.data;
};

/**
 * Fetch all messages for a specific session.
 * GET /rag/rfp/{rfp_id}/sessions/{session_id}/messages
 */
export const fetchSessionMessages = async (rfpId, sessionId) => {
    const response = await api.get(`/rag/rfp/${rfpId}/sessions/${sessionId}/messages`);
    return response.data;
};

/**
 * Delete a specific session.
 * DELETE /rag/rfp/{rfp_id}/sessions/{session_id}
 */
export const deleteSession = async (rfpId, sessionId) => {
    const response = await api.delete(`/rag/rfp/${rfpId}/sessions/${sessionId}`);
    return response.data;
};

/**
 * Rename a specific session.
 * PUT /rag/rfp/{rfp_id}/sessions/{session_id}/rename
 */
export const renameSession = async (rfpId, sessionId, title) => {
    const response = await api.put(`/rag/rfp/${rfpId}/sessions/${sessionId}/rename`, { title });
    return response.data;
};

/**
 * Connect to SSE live streaming for AI responses.
 * POST /rag/rfp/{rfp_id}/chat/stream
 *
 * Backend strictly requires JSON body with { message, session_id }.
 * - Pass session_id=null for the very first message (backend will create a new session).
 * - Pass the saved session_id for all follow-up messages to continue the conversation.
 */
export const startChatStream = async (rfpId, userMessage, sessionId = null) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://velocityrfp-api.engageapp.cloud';

    const url = `${baseUrl}/rag/rfp/${rfpId}/chat/stream`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'text/event-stream'
        },
        body: JSON.stringify({
            message: userMessage,
            session_id: sessionId || null   // null on first message; persisted ID on subsequent ones
        })
    });

    if (!response.ok) {
        throw new Error("Failed to connect to chat stream");
    }

    return response.body.getReader();
};
